const PREFIX = "Shared/User/";

export const RECEIVE_USER = `${PREFIX}RECEIVE_USER`;
export const RECEIVE_USERS = `${PREFIX}RECEIVE_USERS`;
